export const SET_PASSWORD_SUCCEEDED = 'Actions/SET_PASSWORD_SUCCEEDED';
export const SET_PASSWORD_FAILURE = 'Actions/SET_PASSWORD_FAILURE';
export const INVALID_CODE = 'Actions/INVALID_CODE';
export const VALID_CODE = 'Actions/VALID_CODE';

export const LOADING_STATE = 'Actions/LOADING_STATE';

export const GET_EMAILS_VALUES_SUCCEEDED = 'Action/GET_EMAILS_VALUES_SUCCEEDED';
export const REVERT_TO_OLD_EMAIL_SUCCEEDED = 'Action/REVERT_TO_OLD_EMAIL_SUCCEEDED';
export const REVERT_TO_OLD_EMAIL_ERROR = 'Action/REVERT_TO_OLD_EMAIL_ERROR';
export const PASSWORD_RESET_CONFIRMATION_SENT = 'Action/PASSWORD_RESET_CONFIRMATION_SENT';
export const PASSWORD_RESET_CONFIRMATION_FAILED = 'Action/PASSWORD_RESET_CONFIRMATION_FAILED';

export const EMAIL_VERIFICATION_SUCCEEDED = 'Action/EMAIL_VERIFICATION_SUCCEEDED';
export const EMAIL_VERIFICATION_ERROR = 'Action/EMAIL_VERIFICATION_ERROR';

export const SIGNIN_WITH_EMAIL_LINK_SUCCEEDED = 'Action/SIGNIN_WITH_EMAIL_LINK_SUCCEEDED';
export const SIGNIN_WITH_EMAIL_LINK_ERROR = 'Action/SIGNIN_WITH_EMAIL_LINK_ERROR';